<label [id]="labelId" [for]="id()" [attr.aria-label]="label()">
  <input class="visually-hidden" [id]="id()" type="radio" [value]="value()" />
  <odl-icon name="check" />
</label>
<odl-tooltip [attr.for]="'#' + labelId">{{ label() }}</odl-tooltip>
